export const INITIALIZE_WORKFLOW_STATE = "INITIALIZE_WORKFLOW_STATE";
export const GET_WORKFLOW_STATE = "GET_WORKFLOW_STATE";
export const UPDATE_WORKFLOW_STATE = "UPDATE_WORKFLOW_STATE";
export const RESET_WORKFLOW_STATE = "RESET_WORKFLOW_STATE";
